import { useTranslation } from 'react-i18next'
import {
  connect,
  currentPage,
  currentPageParams,
  DataClass,
  navigateTo,
} from 'scrivito'

import { CreateMenuButton } from '@/Atomic/Widgets/CreateMenuButton'
import { DataClassListDrawer } from '@/Atomic/Widgets/DataClassDrawer/DataClass.ListDrawer'
import { DataClassName } from '@/Data/const'

interface ListCreateActionProps {
  dataClass: DataClass
}

export const ListCreateAction: React.FC<ListCreateActionProps> = connect(
  ({ dataClass }: ListCreateActionProps) => {
    const { t } = useTranslation()
    const { drawer, drawer_id, contact_entity, ...rest } = currentPageParams()
    const isOpen =
      drawer === dataClass.name() && drawer_id === `new_${dataClass.name()}`
    const selectedContactEntity =
      contact_entity === DataClassName.COMPANY
        ? DataClassName.COMPANY
        : DataClassName.PERSON

    const openDrawer = (
      contactEntity: DataClassName.COMPANY | DataClassName.PERSON,
    ) => {
      navigateTo(currentPage(), {
        ...currentPageParams(),
        params: {
          drawer: dataClass.name(),
          drawer_id: `new_${dataClass.name()}`,
          contact_entity: contactEntity,
        },
      })
    }

    const closeDrawer = () => {
      navigateTo(currentPage(), rest)
    }

    return (
      <>
        <CreateMenuButton
          label={t('pages.list.createList')}
          menuItems={[
            {
              label: t('sidebar.navigation.item.persons'),
              onClick: () => openDrawer(DataClassName.PERSON),
            },
            {
              label: t('sidebar.navigation.item.companies'),
              onClick: () => openDrawer(DataClassName.COMPANY),
            },
          ]}
          size="sm"
        />
        <DataClassListDrawer
          dataClass={dataClass}
          contactEntity={selectedContactEntity}
          isOpen={isOpen}
          close={closeDrawer}
        />
      </>
    )
  },
)
